import { render, staticRenderFns } from "./NewReservation.vue?vue&type=template&id=65781525&scoped=true&"
import script from "./NewReservation.vue?vue&type=script&lang=js&"
export * from "./NewReservation.vue?vue&type=script&lang=js&"
import style0 from "./NewReservation.vue?vue&type=style&index=0&id=65781525&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65781525",
  null
  
)

export default component.exports